<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="min-h-screen flex">

  <!-- Left: Dark brand panel with form -->
  <div class="w-1/2 flex justify-center items-center relative overflow-hidden"
       style="background: linear-gradient(145deg, #07073C 0%, #0d0d60 50%, #04042A 100%);">

    <!-- Decorative background glows -->
    <div class="absolute top-0 right-0 w-80 h-80 rounded-full opacity-[0.06]"
         style="background: #F9992B; filter: blur(80px); transform: translate(40%, -40%);"></div>
    <div class="absolute bottom-0 left-0 w-64 h-64 rounded-full opacity-[0.05]"
         style="background: #4F46E5; filter: blur(60px); transform: translate(-40%, 40%);"></div>
    <div class="absolute top-1/2 left-1/2 w-96 h-96 rounded-full opacity-[0.03]"
         style="background: #F9992B; filter: blur(100px); transform: translate(-50%, -50%);"></div>

    <!-- Form panel -->
    <div class="w-full max-w-md px-10 relative z-10">

      <!-- Logo + brand -->
      <div class="flex items-center gap-3 mb-12">
        <img src="assets/images/pmc_logo2.svg" alt="PMC Logo" class="h-10 brightness-0 invert opacity-90" />
        <div class="w-px h-8 bg-white/15"></div>
        <div>
          <p class="text-white/90 text-sm font-bold leading-tight">Admin Portal</p>
          <p class="text-white/35 text-[0.65rem] font-medium tracking-wide uppercase mt-0.5">Property Management Console</p>
        </div>
      </div>

      <!-- Headline -->
      <div class="mb-8">
        <h2 class="text-[1.875rem] font-extrabold text-white leading-tight tracking-tight">
          Welcome back
        </h2>
        <p class="text-white/40 text-sm mt-2">Sign in to continue to your dashboard</p>
      </div>

      <!-- Error -->
      <div *ngIf="errorMessage"
           class="mb-5 px-4 py-3 rounded-xl border text-sm font-medium"
           style="background: rgba(239,68,68,0.12); border-color: rgba(239,68,68,0.2); color: #FCA5A5;">
        {{ errorMessage }}
      </div>

      <!-- Form -->
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-4">

        <!-- Email -->
        <div>
          <div class="relative">
            <span class="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
              <img src="assets/icons/email.svg" alt="Email Icon" class="h-4 w-4 brightness-0 invert opacity-35" />
            </span>
            <input
              formControlName="emailAddress"
              type="email"
              class="w-full h-[52px] pl-11 pr-4 text-white text-sm font-medium rounded-xl transition-all focus:outline-none placeholder:font-normal"
              placeholder="Email address"
              style="background: rgba(255,255,255,0.08); border: 1.5px solid rgba(255,255,255,0.12);"
              onfocus="this.style.borderColor='#F9992B'; this.style.background='rgba(255,255,255,0.12)'; this.style.boxShadow='0 0 0 3px rgba(249,153,43,0.12)'"
              onblur="this.style.borderColor='rgba(255,255,255,0.12)'; this.style.background='rgba(255,255,255,0.08)'; this.style.boxShadow='none'"
            />
          </div>
          <p *ngIf="loginForm.get('emailAddress')?.invalid && loginForm.get('emailAddress')?.touched"
             class="text-red-400 text-xs mt-1.5 ml-1">
            Please enter a valid email address.
          </p>
        </div>

        <!-- Password -->
        <div>
          <div class="relative">
            <span class="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
              <img src="assets/icons/key.svg" alt="Password Icon" class="h-4 w-4 brightness-0 invert opacity-35" />
            </span>
            <input
              formControlName="password"
              [type]="passwordVisible ? 'text' : 'password'"
              class="w-full h-[52px] pl-11 pr-12 text-white text-sm font-medium rounded-xl transition-all focus:outline-none placeholder:font-normal"
              placeholder="Password"
              style="background: rgba(255,255,255,0.08); border: 1.5px solid rgba(255,255,255,0.12);"
              onfocus="this.style.borderColor='#F9992B'; this.style.background='rgba(255,255,255,0.12)'; this.style.boxShadow='0 0 0 3px rgba(249,153,43,0.12)'"
              onblur="this.style.borderColor='rgba(255,255,255,0.12)'; this.style.background='rgba(255,255,255,0.08)'; this.style.boxShadow='none'"
            />
            <span
              class="absolute inset-y-0 right-0 flex items-center pr-4 cursor-pointer"
              (click)="togglePasswordVisibility()"
            >
              <img
                [src]="passwordVisible ? 'assets/icons/show_password.svg' : 'assets/icons/hide_password.svg'"
                [alt]="passwordVisible ? 'Hide Password' : 'Show Password'"
                class="h-4 w-4 brightness-0 invert opacity-35 hover:opacity-60 transition-opacity"
              />
            </span>
          </div>
          <p *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
             class="text-red-400 text-xs mt-1.5 ml-1">
            Password must be at least 6 characters long.
          </p>
        </div>

        <!-- Submit -->
        <button
          type="submit"
          [disabled]="loginForm.invalid || isLoggingIn"
          class="w-full h-[52px] mt-2 font-bold text-sm rounded-xl transition-all disabled:opacity-40 disabled:cursor-not-allowed"
          style="background: #F9992B; color: white;"
          onmouseenter="if (!this.disabled) { this.style.background='#e98b25'; this.style.transform='translateY(-2px)'; this.style.boxShadow='0 8px 24px rgba(249,153,43,0.35)'; }"
          onmouseleave="this.style.background='#F9992B'; this.style.transform=''; this.style.boxShadow='';"
          onmousedown="this.style.transform='translateY(0)';"
        >
          {{ isLoggingIn ? "Signing in..." : "Sign in to Portal" }}
        </button>
      </form>

      <!-- Forgot password -->
      <div class="mt-5 text-center">
        <a
          routerLink="/auth/forgot-password"
          class="text-sm font-medium transition-opacity"
          style="color: rgba(255,255,255,0.35);"
          onmouseenter="this.style.color='rgba(249,153,43,0.7)'"
          onmouseleave="this.style.color='rgba(255,255,255,0.35)'"
        >
          Forgot your password?
        </a>
      </div>

      <!-- Footer -->
      <p class="text-white/20 text-xs text-center mt-10">
        &copy; {{ currentYear }} Property Management Console
      </p>
    </div>
  </div>

  <!-- Right: Property image -->
  <div class="w-1/2 h-screen relative overflow-hidden">
    <img
      src="assets/images/signup.jpeg"
      alt="Property"
      class="w-full h-full object-cover"
    />
    <!-- Subtle overlay gradient -->
    <div class="absolute inset-0"
         style="background: linear-gradient(135deg, rgba(7,7,60,0.3) 0%, transparent 50%, rgba(7,7,60,0.15) 100%);"></div>
  </div>

</div>
